<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: DescendantTreePersonCards                             |
| Section: views/trees                                             |
| Purpose: Descendant tree rendered as linked person cards.         |
+------------------------------------------------------------------+
-->
<template>
    <AncestorTreePersonCards ref="descendantTree" :personId="personId" :selectedGenerations="selectedGenerations"
        :fitToContent="fitToContent" :maxFitZoom="maxFitZoom" :cooperativeGestures="cooperativeGestures"
        :familyGroups="familyGroups" :initialRootPerson="initialRootPerson"
        :includeOriginSiblings="includeOriginSiblings" treeMode="descendants"
        @layout-change="$emit('layout-change', $event)" />
</template>

<script>
import AncestorTreePersonCards from '@/views/trees/AncestorTreePersonCards.vue';

export default {
    name: 'DescendantTreePersonCards',
    components: {
        AncestorTreePersonCards
    },
    props: {
        personId: {
            type: String,
            required: true
        },
        selectedGenerations: {
            type: Number,
            default: 1
        },
        fitToContent: {
            type: Boolean,
            default: false
        },
        maxFitZoom: {
            type: Number,
            default: 2.4
        },
        cooperativeGestures: {
            type: Boolean,
            default: true
        },
        familyGroups: {
            type: Array,
            default: () => []
        },
        initialRootPerson: {
            type: Object,
            default: null
        },
        includeOriginSiblings: {
            type: Boolean,
            default: false
        }
    },
    emits: ['layout-change'],
    methods: {
        fitToView() {
            return this.$refs.descendantTree?.fitToView?.();
        },
        resetView() {
            return this.$refs.descendantTree?.resetView?.();
        },
        zoomIn() {
            return this.$refs.descendantTree?.zoomIn?.();
        },
        zoomOut() {
            return this.$refs.descendantTree?.zoomOut?.();
        },
        downloadTreeImage() {
            return this.$refs.descendantTree?.downloadTreeImage?.();
        }
    }
};
</script>
